/**
 * Time-of-day greeting plus an approximate "location · timezone" label,
 * derived entirely from the browser's own clock and Intl data -- no
 * geolocation permission requested. The "location" is just the city name
 * baked into the IANA timezone id (e.g. "Europe/Sarajevo" -> "Sarajevo"),
 * so it's an approximation of where the person's computer is configured
 * for, not a verified location.
 */
export function timeOfDayGreeting(date: Date = new Date()): string {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
}

export function approximateLocationAndZone(date: Date = new Date()): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone; // e.g. "Europe/Sarajevo"
  const city = tz.split("/").pop()?.replace(/_/g, " ") ?? tz;

  let short = "";
  try {
    const parts = new Intl.DateTimeFormat(undefined, { timeZoneName: "short" }).formatToParts(date);
    short = parts.find((p) => p.type === "timeZoneName")?.value ?? "";
  } catch {
    // Intl.DateTimeFormat with timeZoneName isn't universally supported in
    // every environment -- fall back to just the city name if it fails.
  }

  return short ? `${city} · ${short}` : city;
}
